import React from "react";
import { Table, Input, Button } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { formatDate } from "../../../Utilities/dateUtils";
import { saveAs } from "file-saver";
import TablePagination from "./TablePagination";
import { useTableControls } from "./useTableControls";

const PAGE_SIZE_OPTIONS = [50, 100, 200, 500, 1000];
const SEARCHABLE_FIELDS = [
  "courseName",
  "moduleName",
  "studentSchoolName",
  "grade",
  "comment",
];

export default function StudentCourseRatings({ comments }) {
  const intl = useIntl();
  const {
    pageRows,
    searchQuery,
    handleSearchChange,
    sortByColumn,
    sortIndicator,
    pagination,
  } = useTableControls(comments, SEARCHABLE_FIELDS, 50);

  const fnExcelReport = () => {
    var tab_text =
      "<table>" +
      "<tr>" +
      "<th>" +
      intl.formatMessage({ id: "Course" }) +
      "</th><th>" +
      intl.formatMessage({ id: "Module" }) +
      "</th><th>" +
      intl.formatMessage({ id: "StudentSchool" }) +
      "</th><th>" +
      intl.formatMessage({ id: "Grade" }) +
      "</th><th>" +
      intl.formatMessage({ id: "Comment" }) +
      "</th><th>" +
      intl.formatMessage({ id: "StudentName" }) +
      "</th><th>" +
      intl.formatMessage({ id: "StudentEmail" }) +
      "</th><th>" +
      intl.formatMessage({ id: "Status" }) +
      "</th><th>" +
      intl.formatMessage({ id: "Score" }) +
      "</th><th>" +
      intl.formatMessage({ id: "ApproximateTimeForGrade" }) +
      "</th>" +
      "</tr>";
    comments.forEach((comment) => {
      tab_text +=
        "<tr>" +
        "<td>" +
        comment.courseName +
        "</td><td>" +
        comment.moduleName +
        "</td><td>" +
        comment.studentSchoolName +
        "</td><td>" +
        comment.grade +
        "</td><td>" +
        comment.comment +
        "</td><td>" +
        comment.studentName +
        "</td><td>" +
        comment.studentEmail +
        "</td><td>" +
        comment.successStatus +
        "</td><td>" +
        comment.score +
        "</td><td>" +
        formatDate(comment.estimatedDate, "yyyy-MM-dd") +
        "</td>" +
        "</tr>";
    });
    tab_text = tab_text + "</table>";
    var data = new Blob(["\ufeff", tab_text], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      encoding: "utf-8",
    });
    saveAs(data, "Betyg1.xls");
  };

  return (
    <div>
      <div className="container-fluid admin-container">
        <Button
          className="mb-2"
          outline
          color="primary"
          onClick={fnExcelReport}
        >
          <FormattedMessage id="ExportToXls" />
        </Button>
        <Input
          type="text"
          className="mb-2"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder={intl.formatMessage({ id: "Search" })}
        />
        <Table
          hover
          className="table table-striped clickable"
          id="grades-table"
        >
          <thead>
            <tr>
              <th onClick={() => sortByColumn("courseName")}>
                <FormattedMessage id="Course" />
                {sortIndicator("courseName")}
              </th>
              <th onClick={() => sortByColumn("moduleName")}>
                <FormattedMessage id="Module" />
                {sortIndicator("moduleName")}
              </th>
              <th onClick={() => sortByColumn("studentSchoolName")}>
                <FormattedMessage id="StudentSchool" />
                {sortIndicator("studentSchoolName")}
              </th>
              <th onClick={() => sortByColumn("grade")}>
                <FormattedMessage id="Grade" />
                {sortIndicator("grade")}
              </th>
              <th onClick={() => sortByColumn("comment")}>
                <FormattedMessage id="Comment" />
                {sortIndicator("comment")}
              </th>
              <th
                onClick={() => sortByColumn("estimatedDate")}
                className="text_no-wrap"
              >
                <FormattedMessage id="ApproximateTimeForGrade" />
                {sortIndicator("estimatedDate")}
              </th>
            </tr>
          </thead>
          <tbody>
            {pageRows.map((comment) => (
              <tr
                style={{ cursor: "text" }}
                key={`${comment.studentId}-${comment.courseId}-${comment.moduleId}-${comment.estimatedDate}`}
              >
                <td>{comment.courseName}</td>
                <td>{comment.moduleName}</td>
                <td>{comment.studentSchoolName}</td>
                <td>{comment.grade}</td>
                <td>{comment.comment}</td>
                <td>{formatDate(comment.estimatedDate, "yyyy-MM-dd")}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <TablePagination {...pagination} pageSizeOptions={PAGE_SIZE_OPTIONS} />
      </div>
    </div>
  );
}
